import { Configuration, MobilePosFormValues } from 'types/configuration'
import Api from './axiosInstance'
import {
  API_CONFIG as AC,
  API_CONFIG,
  API_CRON,
  API_STORE_MGMT,
  API_TALABAT,
} from 'utils/constants'
import {
  API_ALERT_CONFIG,
  API_INSTASHOP_LASTMILE,
  API_KDS,
  API_MAGENTO,
  API_ORDER_TRACKER,
  API_POWER_BI,
} from 'utils/constants/apiPath'

// get site configurations
const fetchConfigurations = ({ fields }: { fields?: string[] } = {}) => {
  return Api.get({ url: AC.CONFIG, params: { fields: fields?.join(',') } })
}

// get site configurations
const fetchClusters = () => {
  return Api.get({ url: AC.CLUSTERS })
}

const fetchEmirates = () => {
  return Api.get({ url: `${API_STORE_MGMT.STORE}/emirates` })
}
// updates site configurations
const updateConfigurations = (id: string, data: Configuration) => {
  return Api.patch({ url: `${AC.CONFIG}/${id}`, data })
}

const updatePosConfigurations = (id: string, data: MobilePosFormValues) => {
  return Api.patch({ url: `${AC.CONFIG}/${id}/mobile`, data })
}

const updateBagImage = (id: string, data: FormData) => {
  return Api.patch({
    url: `${AC.CONFIG}/bag-image/${id}`,
    data: data,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

// create the site configuration for first time
const createConfigurations = (data: Configuration) => {
  return Api.post({ url: AC.CONFIG, data })
}

// Initiate the Magento catalogue sync manual cron
export const initiateMagentoCatalogueManualSync = (
  lastUpdatedDateTime: string,
) => {
  return Api.post({
    url: API_CRON.CRON_MAGENTO_CATALOGUE,
    data: { lastUpdatedDateTime },
  })
}

// Initiate the Fresh system inventory manual cron
const initiateFreshSystemCronManual = (lastUpdatedDateTime: string) => {
  return Api.post({
    url: API_CRON.CRON_FRESH_SYSTEM,
    data: { lastUpdatedDateTime },
  })
}

// Initiate the Pricing manual cron
const initiatePricingCronManual = () => {
  return Api.post({ url: API_CRON.CRON_PRICING })
}

export const initiateProductUpdateCron = (isDeltaSync: boolean = false) => {
  return Api.post({
    url: API_TALABAT.PRODUCT_UPDATE,
    data: { isDeltaSync },
  })
}

export const initiatePromotionUpdateCron = () => {
  return Api.post({
    url: API_TALABAT.PROMOTION_UPDATE,
  })
}

export const updateTalabatConfig = (data: any) => {
  return Api.post({
    url: `${AC.CONFIG}/talabat`,
    data,
  })
}

export const updateApprovalManagers = (data: any) => {
  return Api.post({
    url: `${AC.CONFIG}/approval-managers`,
    data,
  })
}

export const updatePowerBiConfig = (data: any) => {
  return Api.post({
    url: API_POWER_BI.CONFIG,
    data,
  })
}

export const triggerPowerBiManualSync = () => {
  return Api.post({
    url: API_POWER_BI.SYNC,
    data: {},
  })
}

export const updateAlertConfig = (data: any) => {
  return Api.post({
    url: API_ALERT_CONFIG.CONFIG,
    data,
  })
}

export const triggerPowerBiRmaManualSync = () => {
  return Api.post({
    url: API_POWER_BI.RMA_SYNC,
    data: {},
  })
}

export const updateKdsConfig = (data: any) => {
  return Api.post({
    url: API_KDS.CONFIG,
    data,
  })
}

export const triggerKdsManualSync = () => {
  return Api.post({
    url: API_KDS.SYNC,
    data: {},
  })
}

export const updateMagentoConfig = (data: any) => {
  return Api.post({
    url: API_MAGENTO.CONFIG,
    data,
  })
}

export const triggerMagentoInventorySync = () => {
  return Api.post({
    url: API_MAGENTO.SYNC,
    data: {},
  })
}

export const updateInstashopLastmileConfig = (data: any) => {
  return Api.post({
    url: API_INSTASHOP_LASTMILE.CONFIG,
    data,
  })
}

export const triggerInstashopReconciliationSync = () => {
  return Api.post({
    url: API_INSTASHOP_LASTMILE.RECONCILIATION_SYNC,
    data: {},
  })
}

const syncAggregatorCron = () => {
  return Api.post({ url: API_CRON.CRON_SYNC_AGG })
}

const getRmaConfigurations = () => {
  return Api.get({ url: API_CONFIG.RMA })
}

export {
  getRmaConfigurations,
  syncAggregatorCron,
  fetchConfigurations,
  updateConfigurations,
  createConfigurations,
  initiateFreshSystemCronManual,
  initiatePricingCronManual,
  fetchClusters,
  updateBagImage,
  updatePosConfigurations,
  fetchEmirates,
}

export const updateOrderTrackerConfig = (data: any) => {
  return Api.post({
    url: API_ORDER_TRACKER.CONFIG,
    data,
  })
}
